"use client"

import { DDOPTrackPage } from "@repo/shared"
import { useEffect } from "react"

/**
 * 页面级统计埋点组件
 */
const PageTracker = () => {
  useEffect(() => {
    DDOPTrackPage()
  }, [])

  return null
}

export default PageTracker
